import ApprovalStatus from './ApprovalStatus';

export default ApprovalStatus;
